import React from 'react'
import { Link } from 'gatsby'
import { Parallax } from 'react-parallax'
import Form from '../form/form'

const Footer = () => (
  <footer>
    <div className="footer">
      <section id="talk" data-bs-parallax-bg="true">
        <Parallax
          blur={0}
          bgImage={require('../../images/question-bg.jpg')}
          bgImageAlt="the cat"
          strength={800}
        >
          <div className="talkexperts">
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-12 m-auto">
                  <div className="question-content text-center">
                    <h6 className="section-title mb-3 text-white">
                      Do you have questions about Real Estate?
                    </h6>
                    <h2 className="section-subtitle text-white">
                      I have all the answers, seriously try me!
                      <br />
                    </h2>
                    <Link className="cta" to="/contact">
                      Ask Me A Question
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Parallax>
      </section>
      <section id="footer-cont">
        <div className="contsec">
          <div
            data-aos="zoom-out"
            data-aos-duration="1100"
            data-aos-once="true"
            className="container"
          >
            <div className="headfooter">
              <div className="leftlogo_ftr">
                <img src="/img/logo_whites.png" alt="" />
              </div>
              <div class="right_soc_footr">
                <ul>
                  <li>
                    <a
                      href="https://www.facebook.com/ArmstrongRealEstateCompany/"
                      target="_blank"
                      class="hvr-pulse"
                      rel="noopener noreferrer"
                    >
                      <svg
                        style={{
                          width: '24px',
                          height: '24px',
                          float: 'left',
                          display: 'inline-block',
                          'margin-right': '10px',
                        }}
                        viewbox="0 0 24 24"
                      >
                        <path
                          fill="#6a6bcc"
                          d="M17,2V2H17V6H15C14.31,6 14,6.81 14,7.5V10H14L17,10V14H14V22H10V14H7V10H10V6A4,4 0 0,1 14,2H17Z"
                        />
                      </svg>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="container d-inline-flex">
              <div className="row contfoot">
                <div className="col-md-4 col-xs-12 detconts">
                  <span>
                    Started in real estate in 2003 and started my own agency in
                    the spring of 2016.
                  </span>
                  <ul className="contdets">
                    <li>
                      <svg
                        style={{
                          width: '24px',
                          height: '24px',
                          float: 'left',
                          'margin-right': '10px',
                        }}
                        viewbox="0 0 24 24"
                      >
                        <path
                          fill="#5f5f6c"
                          d="M12,2C15.31,2 18,4.66 18,7.95C18,12.41 12,19 12,19C12,19 6,12.41 6,7.95C6,4.66 8.69,2 12,2M12,6A2,2 0 0,0 10,8A2,2 0 0,0 12,10A2,2 0 0,0 14,8A2,2 0 0,0 12,6M20,19C20,21.21 16.42,23 12,23C7.58,23 4,21.21 4,19C4,17.71 5.22,16.56 7.11,15.83L7.75,16.74C6.67,17.19 6,17.81 6,18.5C6,19.88 8.69,21 12,21C15.31,21 18,19.88 18,18.5C18,17.81 17.33,17.19 16.25,16.74L16.89,15.83C18.78,16.56 20,17.71 20,19Z"
                        />
                      </svg>{' '}
                      1965 Dominion Way Suite 100 Colorado Springs, CO 80918
                    </li>
                    <li>
                      <a href="mailto:dan@armstrongrealestateco.com">
                        <svg
                          style={{
                            width: '24px',
                            height: '24px',
                            'margin-right': '6px',
                          }}
                          viewbox="0 0 24 24"
                        >
                          <path
                            fill="#5f5f6c"
                            d="M4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4C2.89,20 2,19.1 2,18V6C2,4.89 2.89,4 4,4M12,11L20,6H4L12,11M4,18H20V8.37L12,13.36L4,8.37V18Z"
                          />
                        </svg>{' '}
                        dan@armstrongrealestateco.com
                      </a>
                    </li>
                    <li>
                      <a href="tel:719.229.2755">
                        <svg
                          style={{
                            width: '24px',
                            height: '24px',
                            'margin-right': '11px',
                          }}
                          viewbox="0 0 24 24"
                        >
                          <path
                            fill="#5f5f6c"
                            d="M15,12H17A5,5 0 0,0 12,7V9A3,3 0 0,1 15,12M19,12H21C21,7 16.97,3 12,3V5C15.86,5 19,8.13 19,12M20,15.5C18.75,15.5 17.55,15.3 16.43,14.93C16.08,14.82 15.69,14.9 15.41,15.18L13.21,17.38C10.38,15.94 8.06,13.62 6.62,10.79L8.82,8.59C9.1,8.31 9.18,7.92 9.07,7.57C8.7,6.45 8.5,5.25 8.5,4A1,1 0 0,0 7.5,3H4A1,1 0 0,0 3,4A17,17 0 0,0 20,21A1,1 0 0,0 21,20V16.5A1,1 0 0,0 20,15.5Z"
                          />
                        </svg>
                        719.229.2755
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4 col-xs-12 quicklnks">
                  <h3> Quick Links</h3>
                  <ul>
                    <li>
                      <Link to="#page-top">Home</Link>
                    </li>
                    <li>
                      <Link to="/contact">Sell My Home</Link>
                    </li>
                    <li>
                      <Link to="/contact">Buy A Home</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact</Link>
                    </li>
                  </ul>
                </div>
                <div className="col-md-4 col-xs-12 prcinganalysis">
                  <h3> Get Home Pricing Analysis</h3>
                  <span>
                    Request an In-depth Home Review from a Colorado Market
                    Expert.
                  </span>
                  <div className="formfootr">
                    <Form
                      form_name="Armstrong Real Estate | Home Pricing Analysis"
                      form_id="5da960a295701c2bd0894238"
                      action="/thank-you"
                      method="post"
                    >
                      <input
                        type="hidden"
                        name="subject"
                        value="Contact Details"
                      />
                      <div className="row m-0 mt-4">
                        <div className="col-sm-12">
                          <input
                            type="text"
                            name="name"
                            placeholder="Enter Name.."
                            required="required"
                          />
                        </div>
                        <div className="col-sm-6">
                          <input
                            type="email"
                            name="email address"
                            placeholder="Email Address"
                            required="required"
                          />
                        </div>
                        <div className="col-sm-6 phoneeval">
                          <input
                            type="text"
                            name="phone"
                            placeholder="Phone"
                            required="required"
                          />
                        </div>
                        <div className="col-sm-12 my-2">
                          <div className="webriq-recaptcha" />
                        </div>
                        <input
                          type="submit"
                          value="Request My Evaluation"
                          className="evalbtn"
                        />
                      </div>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
            <div className="footercopyrigt">
              <div className="container">
                <div className="row">
                  <div className="col-md-6 leftcopy">
                    <p>Copyright 2021 Armstrong Real Estate Company</p>
                  </div>
                  <div className="col-md-6 rightcopy text-right">
                    <p>
                      Designed and Powered by{' '}
                      <a
                        href="http://webriq.com"
                        target="_blank"
                        alt="WebriQ"
                        rel="noopener noreferrer"
                      >
                        WebriQ
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </footer>
)

export default Footer
